import React, { createContext, useContext, useState, useEffect } from 'react';

const FavoritesContext = createContext();

export const useFavorites = () => {
  const context = useContext(FavoritesContext);
  if (!context) {
    throw new Error('useFavorites must be used within FavoritesProvider');
  }
  return context;
};

export const FavoritesProvider = ({ children }) => {
  const [favoriteItems, setFavoriteItems] = useState([]);

  // Carregar favoritos do LocalStorage ao montar
  useEffect(() => {
    const savedFavorites = localStorage.getItem('aug_favorites');
    if (savedFavorites) {
      setFavoriteItems(JSON.parse(savedFavorites));
    }
  }, []);

  // Salvar favoritos no LocalStorage sempre que mudar
  useEffect(() => {
    localStorage.setItem('aug_favorites', JSON.stringify(favoriteItems));
  }, [favoriteItems]);

  // Adicionar ou remover dos favoritos (toggle)
  const toggleFavorite = (product) => {
    setFavoriteItems(prevItems => {
      const existingItem = prevItems.find(item => item.id === product.id);
      
      if (existingItem) {
        // Remove dos favoritos
        return prevItems.filter(item => item.id !== product.id);
      } else {
        // Adiciona aos favoritos
        return [...prevItems, product];
      }
    });
  };

  // Verificar se produto está nos favoritos
  const isFavorite = (productId) => {
    return favoriteItems.some(item => item.id === productId);
  };

  // Remover dos favoritos
  const removeFromFavorites = (productId) => {
    setFavoriteItems(prevItems => prevItems.filter(item => item.id !== productId));
  };

  // Limpar favoritos
  const clearFavorites = () => {
    setFavoriteItems([]);
  };

  // Contar favoritos
  const getFavoritesCount = () => {
    return favoriteItems.length;
  };

  const value = {
    favoriteItems,
    toggleFavorite,
    isFavorite,
    removeFromFavorites,
    clearFavorites,
    getFavoritesCount
  };

  return (
    <FavoritesContext.Provider value={value}>
      {children}
    </FavoritesContext.Provider>
  );
};
